import React, { useEffect, useState } from "react";
import { getHubFlags, resolveHubFlag } from "@/api";

export function HubFlags({ token, showToast }) {
  const [flags, setFlags] = useState(null);
  const load = () => getHubFlags(token).then(setFlags).catch(() => setFlags([]));
  useEffect(() => { load(); }, [token]); // eslint-disable-line
  const act = (id, action) => resolveHubFlag(token, id, action).then(() => { showToast(action === "clear" ? "Hub cleared" : "Hub banned"); load(); })
    .catch((e) => showToast(e?.response?.data?.detail || "Failed", "error"));
  return (
    <div className="card-tile" data-testid="operator-hub-flags">
      <h2 className="font-display text-xl font-bold">Flagged hubs</h2>
      <p className="text-sm text-slate-400 mt-1">Earnings for a flagged hub are on hold. Clearing releases them under the daily cap; banning hides the hub and forfeits held earnings.</p>
      {flags?.length === 0 && <p className="text-sm text-slate-500 mt-3" data-testid="operator-no-flags">No open flags.</p>}
      {flags?.map((f) => (
        <div key={f.id} className="flex flex-wrap items-center gap-3 py-3 border-b border-white/5 text-sm" data-testid={`operator-flag-${f.id}`}>
          <div className="flex-1 min-w-[200px]"><div className="font-bold">{f.hub_name}</div><div className="text-xs text-slate-400">{f.reason}: {f.detail}</div></div>
          <button onClick={() => act(f.id, "clear")} className="btn-tactile btn-ghost text-xs" data-testid={`operator-flag-clear-${f.id}`}>Clear</button>
          <button onClick={() => act(f.id, "ban")} className="btn-tactile btn-flame text-xs" data-testid={`operator-flag-ban-${f.id}`}>Ban hub</button>
        </div>
      ))}
    </div>
  );
}
